import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { getFixedAssetLogsSequence } from "../../../../../../store/actions/precog/assets";
import PurchaseDrawerLogsDetails from "./purchaseDrawerLogsDetails";
import "./style.css";
import DepreciationDrawerLogsDetails from "./deprectionDrawerLogsDetails";
import RevaluationDrawerLogsDetails from "./revaluationDrawerLogsDetails";
import DisposalDrawerLogsDetails from "./disposalDrawerLogsDetails";
import SaleDrawerLogsDetails from "./saleDrawerLogsDetails";

const MovementDrawerDetails = ({sequence, showDrawerDetail, setShowDrawerDetail, assetsDetails, trackType}) => {
  const dispatch = useDispatch();
  const [detailLogs, setDetailLogs] = useState(null);

  useEffect(() => {
    dispatch(getFixedAssetLogsSequence(
      assetsDetails?.id, assetsDetails?.businessId, sequence
    )).then((res) => {
      setDetailLogs(res?.assetLogs);
    });
  }, [sequence]);

  const filteredLogs = detailLogs
    ?.filter(log => log?.trackType === trackType || log?.trackType === null)
    .map(log => ({
      ...log,
      trackType: trackType
    }));

  return (
    <div>
      <div className='pre-cog-assets-drawer-add-movement-text'
        data-testid="popoverButtonDeleteRevaluate"
        onClick={() => setShowDrawerDetail(!showDrawerDetail)}
        style={{cursor: "pointer", color: "#0090d1", marginLeft: "0", marginTop: "-15px"}}
      >
        <FontAwesomeIcon icon={["far", "chevron-left"]} style={{ color: "#0090d1", fontSize: "13px", marginBottom: "2px" }} />
        <span style={{marginLeft: "8px"}}>
          <FormattedMessage id="preCog.assetsTab.drawer.buttons.backButton" />
        </span>
      </div>
      {filteredLogs && (filteredLogs[0]?.type === "PURCHASE" || filteredLogs[0]?.type === "INCREASE") && <PurchaseDrawerLogsDetails filteredLogs={filteredLogs} />} 
      {filteredLogs && filteredLogs[0]?.type === "DEPRECIATION" && <DepreciationDrawerLogsDetails filteredLogs={filteredLogs} />} 
      {filteredLogs && (filteredLogs[0]?.type === "SALE" || filteredLogs[0]?.type === "PARTIALLY_SALE") && <SaleDrawerLogsDetails filteredLogs={filteredLogs} />}
      {filteredLogs && filteredLogs[0]?.type === "REVALUATE" && <RevaluationDrawerLogsDetails filteredLogs={filteredLogs} />}
      {filteredLogs && (filteredLogs[0]?.type === "DISMISS" || filteredLogs[0]?.type === "PARTIALLY_DISMISS") && <DisposalDrawerLogsDetails filteredLogs={filteredLogs} />}
    </div>
  );
};

export default MovementDrawerDetails;